<script>
  import { onMount } from 'svelte';

  export let onClick,  paused = false;

  let initialDeg = 0;

  const centerX = 135;


  const svgRotateOffsetDeg = 0 // 135

  /*
  const leftAnimConfig = {
    offsetX1: centerX - 189.6
  }*/

  onMount(async () => {
    initialDeg = svgRotateOffsetDeg + new Date().getSeconds() * 6;

  /*
    let frame = requestAnimationFrame(loop);
    let framecounter = 0;

    function loop(t) {
      frame = requestAnimationFrame(loop);

      framecounter++
    }

    return () => {
      cancelAnimationFrame(frame);
    };
  */

  });


  const unit = 266/7
  const height = 266
  const width = 266

  const stroke_width = 8


</script>

<svg class:paused style="--start-deg: {initialDeg}deg; --end-deg: {initialDeg+360}deg;" width="266" height="266" viewBox="0 0 266 266" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path stroke-linecap="round" d="M{width/2} {1*unit} V {6*unit}" style="fill:none;fill-rule:nonzero;stroke:black;stroke-width:{stroke_width}px;"/>
  <path stroke-linecap="round" class="left"  d="M{2*unit} {2*unit}        H {5*unit}" style="fill:none;fill-rule:nonzero;stroke:black;stroke-width:{stroke_width}px;"/>
  <path stroke-linecap="round" class="right" d="M{2*unit} {height-2*unit} H {5*unit}" style="fill:none;fill-rule:nonzero;stroke:black;stroke-width:{stroke_width}px;"/>
</svg>

<style lang="scss">
  svg {
    will-change: transform;
    //background: red;
    width: 100%;
    height: 100%;
    transform-origin: 50% 54%; // shift down
    animation-name: clock_shifted;
    animation-duration: 60s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    &.paused, &.paused path {
      animation-play-state: paused;
    }
  }

  /*
  .left-container {
    will-change: transform;
    transform-origin: 50% 50%; 
    animation-name: clock;
    animation-duration: 8s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }*/

  .left { 
    will-change: transform;
    transform-origin: 50% 28.57%; // 2/7
    animation-name: rotatestretch;
    animation-duration: 14s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }

  .right { 
    will-change: transform;
    transform-origin: 50% 71.42%; // 5/7 
    animation-name: clock;
    animation-duration: 20s;
    animation-direction: reverse;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
  }  

  @keyframes clock {
    from { transform: rotateZ(var(--start-deg)); }
    to   { transform: rotateZ(var(--end-deg)); }
  }

  @keyframes clock_shifted {
    from { transform: translateY(-4%) rotateZ(var(--start-deg)); } // shift up
    to   { transform: translateY(-4%) rotateZ(var(--end-deg)); }  // shift up
  }

  @keyframes rotate {
    from { transform: /*rotateZ(   0deg)*/ rotateY(  0deg) ; }
    to   { transform: /*rotateZ( 360deg)*/ rotateY(360deg) ; }
  }  

  @keyframes rotatestretch {
    0%   { transform: rotateZ(   0deg) scaleX(  0) ; }
    33%  { transform: rotateZ( 120deg) scaleX(1.3) ; }
    50%  { transform: rotateZ( 180deg) scaleX(1.5) ; }
    66%  { transform: rotateZ( 240deg) scaleX(1.2) ; }
    100% { transform: rotateZ( 360deg) scaleX(  0) ; }
  }  


</style>